var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hint mb-4"},[(_vm.isVisible)?_c('b-notification',{staticClass:"mt-2",attrs:{"type":"is-white"},on:{"close":_vm.onDismiss}},[_vm._t("default")],2):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }